/*-----------------------------------------------------------------
- Forms translations
-----------------------------------------------------------------*/
export default {

    select: {
        label: {
            group: {
                select  : '',
                deselect: '',
            },
            single: {
                select  : '',
                deselect: '',
            },
            selected: '',
        },
        placeholder: {
            default: 'Choose from the options.',
            tag    : '',
            search : 'Search ...',
        },
        message: {
            no_options: 'There is no option.',
            no_search : 'Search for viewing options',
            no_result : 'The result was not found.',
        },
    },

};
